import { ConfirmDialog } from '@gogame/components';
import { useMutation, useQueryClient } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { deleteCustomMetric } from '../../sources/metrics';
import { metrics, removeCustomMetric as queryKey } from '../queryKeyFactory';
import { customMetricsPredicate } from './utils/customMetricsPredicate';

export const useDeleteMetric = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const queryClient = useQueryClient();

  const deleteMutation = useMutation(queryKey(), deleteCustomMetric, {
    refreshOptions: {
      queryKey: metrics.all(),
    },
    onSuccess: ({ name }) => {
      queryClient.resetQueries({
        predicate: (query) => customMetricsPredicate(query, name),
      });
    },
    successMessage: (_, { groupName, displayName }) => {
      const groupTitle = groupName.includes('Metric') ? `Custom` : groupName;

      return `${groupTitle} Metric «${displayName}» was deleted`;
    },
  });

  const handleAction = async ({ groupName, displayName, id }) => {
    const groupTitle = groupName.includes('Metric') ? `Custom` : groupName;

    await showModal({
      title: `Delete ${groupTitle} Metric?`,
      confirmActionLabel: 'Delete',
      bodyText: `«${displayName}»`,
    });
    await deleteMutation.mutateAsync({ groupName, displayName, id });
  };

  return [handleAction, deleteMutation.mutateAsync];
};
